import React, { useEffect, useState, useRef, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
// import ReactGA from 'react-ga';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import {
  COURSES_LIST_PATH,
  API_SHOW_REGISTER_FORM,
  API_MEMBERSHIPS_DETAILS,
  FRONTENDLMS_URL,
  API_USER_ENROLLMENT,
  API_GROUP_MODE,
  API_SCHEDULER_MEMBERSHIP
} from '../../../Domain/Redux/Paths';
import {
  GOOGLE_ADWORDS_CONVERSION_ID,
  GOOGLE_ANALITY_MEASURENMENT_ID
} from '../../../Domain/Settings/Keys/Keys';

import { Helmet } from 'react-helmet';
import { CustomHelmet } from '../../Atoms/CustomHelmet/CustomHelmet';
import { getScreenImage } from '../../../Domain/Utils/ScreenUtilies/ScreenUtilies';
import '../../../Generals/Styles/Rows.css';
import '../../../Generals/Styles/Fonts.css';
import CustomLoadingOverlay from '../../Atoms/CustomLoadingOverlay/CustomLoadingOverlay';
import ArrowIndicator from '../../Atoms/ArrowIndicator/ArrowIndicator';
import WhyChooseUsCardGroup from '../../Molecules/WhyChooseUsCardGroup/WhyChooseUsCardGroup';
import {
  useGetComponentParameters,
  useGetComponentParametersSingle
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import useLanguageRedirect from '../../../Core/Hooks/HookUrlRedirect/useLanguageRedirect';
import {
  COURSE_MODE,
  ROLE,
  STAY_KEYS,
  TYPE_FETCH_PARAMETERS
} from '../../../Domain/Settings/Constants/Constants';
import { WhyTakeCourse } from '../../Atoms/WhyTakeCourse/WhyTakeCourse';
import {
  transformConsultantDataVariables,
  transformConsultantsData,
  transformData
} from '../../../Domain/Utils/TransformDataUtilities/TransformData';

import './CourseInfoScreen.css';
import TapsCourse from '../../Atoms/TapsCourse/TapsCourse';
import { useContentCarousel } from '../../Organisms/ContentCarousel/useContentCarousel';
import MembershipSection from '../../Organisms/MembershipSection/MembershipSection';
import BenefitsAndCertifications from '../../Organisms/BenefitsAndCertifications/BenefitsAndCertifications';
import { desktop_general_tap } from '../../../Resources/Images/ImagesLogo';
import PaymentMethods from '../../Organisms/PaymentMethods/PaymentMethods';
import ConsultantsComponent from '../../Molecules/ConsultantsComponent/ConsultantsComponent';
import BuyCourseCarouselComponent from '../../Molecules/BuyCourseCarouselComponent/BuyCourseCarouselComponent';
import BrochureBanner from '../../Molecules/BrochureBanner/BrochureBanner';
import { getParamFromUrl } from '../../../Domain/Utils/UrlUtilies/UrlUtilies';
import ModalGeneral from '../../Modals/ModalGeneral/ModalGeneral';
import CustomCheck from '../../Atoms/CustomCheck/CustomCheck';
import { Bold, EventInfo, Paragraph } from '../../Atoms';
import { getFormattedDateMultilanguage } from '../../../Domain/Utils/DateUtilities/DateUtilities';
import FixedBar from '../../Atoms/FixedBar/FixedBar';
import useIsMobile from '../../../Core/Hooks/HooksGenerals/UseIsMobile';
import InfoErrorCode from '../../Atoms/InfoErrorCode/InfoErrorCode';
import { UserRegisterForm } from '../../Organisms/UserRegisterForm/UserRegisterForm';
import { useCombinedObjects } from '../../../Domain/Utils/ApiUtilies/Parameters/Parameters';
import useMembershipPriceDefault from './useMembershipPriceDefault';
import { RegisterPopUp } from '../../Organisms/RegisterPopUp/RegisterPopUp';
import { handleMessage } from '../../../Domain/Utils/TextUtilities/textUtilities';
// import { RegisterPopUp } from '../../Molecules/RegisterPopUp/RegisterPopUp';

const MSG_UPDATE = 'User enrollment updated';
const MSG_CREATE = 'User enrollment created';
const MSG_EQUAL_EMAIL = 'Your user can not be a reference';
const MSG_ENROLLMENT_EXIST = 'User enrollment already exists';
const MSG_CREATE_UPDATE = 'User enrollment created!';

// course info screen
const CourseInfoScreen = (props) => {
  const groupCheck = useRef({ silver: [], platinium: [], schedulerId: null });
  const sectionReference = useRef(null);
  const sectionMembership = useRef(null);
  const scrollContainerRef = useRef(null);
  const { location } = props;
  const [loader, setLoader] = useState(true);
  const history = useHistory();
  const [courseItem, setCourseItem] = useState(null);
  const [courseForBanner, setCourseForBanner] = useState(null);

  const [showRegisterForm, setShowRegisterForm] = useState(false);
  // const [resources, setResources] = useState([]);

  const [schedulerListCourse, setSchedulerListCourse] = useState([]);
  const [showPopUp, setShowPopUp] = useState({ show: false, additional_product: null });
  const [membershipList, setMembershipList] = useState([]);

  const [showSelectScheduler, setShowSelectScheduler] = useState({ show: false, membership: {} });
  const [selectBuyScheduler, setSelectBuyScheduler] = useState(null);
  const [showEnrrolmentForm, setShowEnrrolmentForm] = useState(false);

  const [shouldTrack, setShouldTrack] = useState(false);
  const [selectedSchedulerId, setSelectedSchedulerId] = useState(null);
  const [errorMembership, setErrorMembership] = useState({});
  const [membershiSelectClic, setMembershiSelectClic] = useState();
  const [nameMembershipsGroup, setNameMembershipsGroup] = useState([]);

  const [show, setShow] = useState(false);

  const [modalSucces, setModalSucces] = useState(false);
  const [modalError, setModalError] = useState({ show: false, title: null, subtitle: null });
  const [nameForm, setNameForm] = useState('');
  const [showBtnsMemberships, setShowBtnsMemberships] = useState(false);
  const [currentSelectMembership, setCurrentSelectMembership] = useState({
    groupSelected: 2,
    schedulerId: null
  });
  const [loaderForm, setLoaderForm] = useState(false);
  const [messageError, setMessageError] = useState('');

  const courseCampaigns = [89];
  const parametersBannerMlt = useGetComponentParameters(COMPONENTS.BANNER_PRINCIPAL_SECTION);
  const parametersBannerStd = useGetComponentParametersSingle(
    COMPONENTS.BANNER_PRINCIPAL_SECTION,
    TYPE_FETCH_PARAMETERS.STANDARD
  );
  const parametersBanner = useCombinedObjects(parametersBannerMlt, parametersBannerStd);

  const parametersFormMlt = useGetComponentParameters(COMPONENTS.FORM_INTEREST_REGISTER);
  const parametersFormStd = useGetComponentParametersSingle(
    COMPONENTS.FORM_INTEREST_REGISTER,
    TYPE_FETCH_PARAMETERS.STANDARD
  );

  const parametersForm = useCombinedObjects(parametersFormMlt, parametersFormStd);

  const parametersPaymentMethos = useGetComponentParameters(COMPONENTS.PAYMENTS_METHODS_SECTION);

  const parametersContentCarrousel = useGetComponentParameters(
    COMPONENTS.CONTENT_CARROUSEL_SECTION
  );

  const parametersMlt = useGetComponentParameters(COMPONENTS.COURSE_INFO_SCREEN);

  const parametersDetail = useGetComponentParametersSingle(
    COMPONENTS.COURSE_INFO_SCREEN,
    TYPE_FETCH_PARAMETERS.DETAIL
  );
  const parameters = useCombinedObjects(parametersMlt, parametersDetail);

  const parametersMembershipMlt = useGetComponentParameters(COMPONENTS.MEMBERSHIP_INTEREST_SECTION);
  const parametersMembershipStd = useGetComponentParametersSingle(
    COMPONENTS.MEMBERSHIP_INTEREST_SECTION,
    TYPE_FETCH_PARAMETERS.STANDARD
  );
  const parametersMembership = useCombinedObjects(parametersMembershipMlt, parametersMembershipStd);

  const benefictsParamsMlt = useGetComponentParameters(
    COMPONENTS.BENEFECITS_CERTIFICATIONS_SECTION
  );
  const benefictsParamsStd = useGetComponentParametersSingle(
    COMPONENTS.BENEFECITS_CERTIFICATIONS_SECTION,
    TYPE_FETCH_PARAMETERS.STANDARD
  );

  const benefictsParamsDetail = useGetComponentParametersSingle(
    COMPONENTS.BENEFECITS_CERTIFICATIONS_SECTION,
    TYPE_FETCH_PARAMETERS.DETAIL
  );
  const benefictsParams = useCombinedObjects(
    benefictsParamsMlt,
    benefictsParamsStd,
    benefictsParamsDetail
  );

  const parametersBrouchureMlt = useGetComponentParameters(COMPONENTS.COURSE_MOTIVATE_SECTION);
  const parametersBrouchureDetail = useGetComponentParametersSingle(
    COMPONENTS.COURSE_MOTIVATE_SECTION,
    TYPE_FETCH_PARAMETERS.DETAIL
  );
  const parametersBrouchure = useCombinedObjects(parametersBrouchureMlt, parametersBrouchureDetail);
  const parametersAboutDudes = useGetComponentParameters(COMPONENTS.SOLVE_QUESTIONS_SECTION);
  const parametersWhyChoiseMlt = useGetComponentParameters(COMPONENTS.WHY_CHOISE_LT_SECTION);

  const parametersWhyChoiseDetail = useGetComponentParametersSingle(
    COMPONENTS.WHY_CHOISE_LT_SECTION,
    TYPE_FETCH_PARAMETERS.DETAIL
  );

  const parametersWhyChoise = useCombinedObjects(parametersWhyChoiseMlt, parametersWhyChoiseDetail);

  const { temporal } = useContentCarousel({ courseContentList: courseItem?.content_set });

  const languageKey = useSelector((store) => store.languageTraslate.language) || {
    id: 3,
    name: 'Ingles',
    description: 'En',
    value: 3
  };

  useLanguageRedirect();

  const { membershiPriceDefault } = useMembershipPriceDefault(
    selectedSchedulerId ?? schedulerListCourse?.[0],
    courseItem?.mode?.[0]?.id
  );

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollLeft = container.scrollWidth;
    }
  }, [membershipList]);

  useEffect(() => {
    if (!languageKey?.value) return;

    const loadInitialData = async () => {
      const courseId = Object.fromEntries(new URLSearchParams(location.search))?.course;
      if (!courseId || !languageKey) return;
      setLoader(true);
      try {
        const courseResponse = await HttpClient.GET(COURSES_LIST_PATH, {
          course_id: courseId,
          language: languageKey.value,
          component: COMPONENTS.DETAIL_COURSE_INFORMATION
        });
        const course = courseResponse.results[0];

        if (!course) return;
        const courseInformation = transformData(course?.course_information);
        const variableMap = {
          7: 'position',
          8: 'professional_profile'
        };

        const consultant_data = transformConsultantsData(course?.consultant_data, variableMap);

        const infoCourse = {
          ...course,
          ...courseInformation,
          ...consultant_data
        };

        delete infoCourse.course_information;

        setSchedulerListCourse(infoCourse?.scheduler_fields);

        handleUpdateSelection(parseInt(infoCourse?.scheduler_fields?.[0]?.id));
        setCourseItem(infoCourse);
        setCourseForBanner({
          name: infoCourse.name,
          desktop_image: getScreenImage(infoCourse),
          description: infoCourse.banner_message
        });
      } catch (error) {
        console.debug('>>>> CourseInfoScreen.loadInitialData: error=', error);
        // * go to /interest-area?interest_area=X | works if the user navigate correctly
        history.goBack();
      } finally {
        setLoader(false);
      }
    };
    if (languageKey?.value) {
      loadInitialData();
    }
  }, [languageKey]);

  useEffect(() => {
    if (
      !languageKey?.value ||
      !parametersMembership?.GROUP_MEMBERSHIP_DEFAULT?.value ||
      nameMembershipsGroup?.length === 0 ||
      !courseItem
    )
      return;

    const schedulerId = courseItem?.scheduler_fields?.[0]?.id;
    const modeId = courseItem?.mode?.[0]?.id;
    const groupMembership = parseInt(parametersMembership?.GROUP_MEMBERSHIP_DEFAULT?.value);
    // getMembershipPrices(courseItem, modeId, schedulerId);
    fetchMembershipCardsLessScheduler(schedulerId, modeId, groupMembership);
  }, [
    languageKey,
    parametersMembership?.GROUP_MEMBERSHIP_DEFAULT?.value,
    nameMembershipsGroup,
    courseItem
  ]);

  useEffect(() => {
    // fetchNameMembershpGroup();

    const handleScroll = () => {
      if (!shouldTrack && window.scrollY > 100) {
        setShouldTrack(true);
        window.removeEventListener('scroll', handleScroll);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (shouldTrack) {
      ReactGA.initialize(GOOGLE_ANALITY_MEASURENMENT_ID);
      ReactGA.send({ hitType: 'pageview', page: '/course-info', title: 'Course Detail' });

      ReactGA.event({
        category: 'conversion',
        action: 'CourseDetailConversion',
        value: 0,
        send_to: GOOGLE_ADWORDS_CONVERSION_ID
      });

      ReactPixel.trackCustom('CourseDetail', { path: '/course' });
    }
  }, [shouldTrack]);

  useEffect(() => {
    if (courseItem?.pk) {
      getAditionalProducto(courseItem?.pk);
      fetchCountMembershipGroup(courseItem?.mode?.[0]?.id);
    }
    if (courseItem?.show_register_form && courseItem?.show_register_form !== 'False') {
      setShowRegisterForm(true);
      document.getElementsByTagName('html')[0].style.overflowY = 'clip';
    } else {
      document.getElementsByTagName('html')[0].style.overflowY = 'scroll';
    }
  }, [courseItem]);

  const getSMSource = () => {
    const queryURL = window.location.search;
    const params = new URLSearchParams(queryURL);
    return params.get('fromsm');
  };

  function getUTMParam(param) {
    const params = new URLSearchParams(window.location.search);
    return params.get(param);
  }
  const utmSource = getUTMParam('utm_source');
  if (utmSource) {
    sessionStorage.setItem('utm_source', utmSource);
  }

  const getAditionalProducto = (course) => {
    HttpClient.GET(API_SHOW_REGISTER_FORM, { course }).then((res) => {
      setShowPopUp({ show: false, additional_product: null });
      if (res?.[0]) {
        setShowPopUp({ show: true, additional_product: res?.[0]?.value });
      }
    });
  };

  const scrollToCourseCard = () => {
    sectionReference.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToCourseMembership = () => {
    sectionMembership.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleBuy = async (membershipSelect, key = false) => {
    setErrorMembership({});
    let membership;
    let schedulerId;
    let membershipPrice;
    if (schedulerListCourse?.length === 1) {
      const scheduler = schedulerListCourse[0];
      schedulerId = scheduler.id;
      membership = membershipSelect;
    }

    if (key) {
      schedulerId = membershipSelect;
      const membershipPriceGoss = await HttpClient.GET(API_SCHEDULER_MEMBERSHIP, {
        scheduler_id: parseInt(membershiSelectClic.scheduler_id),
        mode_id: courseItem?.mode?.[0]?.id,
        role_id: membershiSelectClic.membership_id
      });
      membershipPrice = membershipPriceGoss?.content;
    }

    const desectructurinMembership = key ? membershipPrice : membership;

    if (!desectructurinMembership) setErrorMembership(membershiSelectClic);

    const { id, main_currency, price, membership_id } = key
      ? desectructurinMembership?.[0]
      : desectructurinMembership;
    const mainCurrency =
      main_currency ?? price?.main_currency === '' ? 'USD' : price?.main_currency;
    const course_id = getParamFromUrl('course');
    const languageDes = languageKey?.description;

    window.location.href =
      FRONTENDLMS_URL +
      `/login?rto=${FRONTENDLMS_URL}%2F${languageDes?.toLowerCase()}%2Fpayments%3Fcourse_id%3D${course_id}%26scheduler_membership_price%3D${
        price?.id ?? id
      }%26scheduler_id%3D${schedulerId}%26membership_id%3D${
        membership_id ?? membershiSelectClic.membership_id
      }%26is_portal%3D${true}%26main_currency%3D${main_currency ?? mainCurrency}`;
  };

  const handleSelectScheduler = (membership) => {
    if (membership?.price === '' && membership?.membership_id !== ROLE.COURTESY) return;
    if (schedulerListCourse?.length === 1) {
      handleBuy(membership);
      return;
    }
    setMembershiSelectClic(membership);
    setShowSelectScheduler((prev) => ({ ...prev, show: true, membership: membership }));
  };

  const backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 78.96%, #000 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.90) 100%), url(${
      getScreenImage(parameters?.ALL_OUR_PLATFORMS) || desktop_general_tap
    })`,
    backgroundSize: '',
    backgroundRepeat: 'no-repeat',
    borderTop: '1px solid transparent'
  };
  const isMobile = useIsMobile();

  const updateData = async (data, method) => {
    try {
      setLoaderForm(true);
      const resEnrollment = await HttpClient[method](API_USER_ENROLLMENT, data);

      const existe = Array.isArray(resEnrollment?.content)
        ? resEnrollment.content.includes('user phone already exists')
        : typeof resEnrollment?.content === 'string' &&
          resEnrollment.content.includes('user phone already exists');

      const existeNo = Array.isArray(resEnrollment?.data)
        ? resEnrollment.data.includes('user phone already exists')
        : typeof resEnrollment?.data === 'string' &&
          resEnrollment.data.includes('user phone already exists');

      if (existe || existeNo) {
        const msg = handleMessage('user phone already exists', parameters);
        setMessageError(msg);
        setLoaderForm(false);
        return;
      }

      if (
        resEnrollment?.message === MSG_CREATE ||
        resEnrollment?.message === MSG_UPDATE ||
        resEnrollment?.message === MSG_CREATE_UPDATE
      ) {
        setModalSucces(true);
      } else if (resEnrollment.message === MSG_EQUAL_EMAIL) {
        setShow(false);
        setModalError({
          show: true,
          title: parameters?.INF_MSG_55?.value,
          subtitle: parameters?.YOU_CANT_BE_REF?.value
        });
      } else if (resEnrollment.message === MSG_ENROLLMENT_EXIST) {
        setShow(false);
        setModalError({
          show: true,
          title: parameters?.INF_MSG_55?.value,
          subtitle: parameters?.ENROLLMENT_EXIST?.value ?? parameters?.YOU_CANT_BE_REF?.value
        });
      }
      setShow(false);
      setShowEnrrolmentForm(false);
      setLoaderForm(false);
      // reset();
    } catch (error) {
      setLoaderForm(false);
    }
  };

  const fetchCountMembershipGroup = async (mode_id) => {
    const payload = mode_id
      ? selectedSchedulerId
        ? { mode_id, scheduler_id: selectedSchedulerId }
        : { mode_id }
      : {};
    setLoader(true);
    try {
      const countGroup = await HttpClient.GET(API_GROUP_MODE, payload);
      if (countGroup.content.length > 0) {
        setNameMembershipsGroup(
          countGroup.content.reduce((acc, item) => {
            acc[item.name.toUpperCase()] = { name: item.name, id: item.pk };
            return acc;
          }, {})
        );
      }
      const count = countGroup?.content?.length > 1;
      setShowBtnsMemberships(count);
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleUpdateSelection = (schedulerId) => {
    setSelectedSchedulerId(schedulerId);
    setSelectBuyScheduler(schedulerId);
  };

  const handleUpdateMemberships = (schedulerId, key) => {
    setSelectedSchedulerId(schedulerId);
    setSelectBuyScheduler(schedulerId);

    fetchMembershipCardsLessScheduler(
      schedulerId,
      courseItem?.mode?.[0]?.id,
      currentSelectMembership?.groupSelected
    );
  };

  const fetchMembershipCardsLessScheduler = async (schedulerId, modeId, groupMembership) => {
    const groupSelect = groupMembership
      ? groupMembership || currentSelectMembership.groupSelected
      : parseInt(parametersMembership?.GROUP_MEMBERSHIP_DEFAULT?.value);

    const schedulerSilver = groupCheck.current.silver?.[0]?.scheduler_id;
    const validationSilver =
      (groupSelect === nameMembershipsGroup?.SILVER?.id &&
        groupCheck.current.silver.length === 0) ||
      schedulerSilver
        ? schedulerSilver != schedulerId
        : false;

    const schedulerPlatinium = groupCheck.current.platinium?.[0]?.scheduler_id;
    const validationPlatinium =
      (groupSelect === nameMembershipsGroup?.PLATINUM?.id &&
        groupCheck.current.platinium.length === 0) ||
      schedulerPlatinium
        ? schedulerPlatinium != schedulerId
        : false;

    const payload = schedulerId
      ? {
          schedulerId: schedulerId ?? membershipList?.[0]?.scheuler_id,
          modeId: modeId ?? courseItem?.mode?.[0]?.id,
          multilanguage_id: languageKey?.id,
          default_membership: groupSelect,
          component: COMPONENTS.ROLE
        }
      : {
          multilanguage_id: languageKey.id,
          modeId: courseItem?.mode?.[0]?.id ?? modeId ?? parseInt(COURSE_MODE.TELEPRESENCE),
          default_membership: groupSelect,
          component: COMPONENTS.ROLE
        };
    setLoader(true);
    try {
      if (
        groupCheck.current.silver.length === 0 ||
        groupCheck.current.platinium.length === 0 ||
        parseInt(groupCheck.current.silver?.[0]?.scheduler_id) !== schedulerId ||
        parseInt(groupCheck.current.platinium?.[0]?.scheduler_id) !== schedulerId ||
        groupCheck.current.schedulerId !== schedulerId
      ) {
        const memberships = await HttpClient.GET(API_MEMBERSHIPS_DETAILS, payload);
        if (memberships?.content?.length > 0) {
          if (validationSilver) {
            groupCheck.current.silver = memberships?.content;
          } else if (validationPlatinium) {
            groupCheck.current.platinium = memberships?.content;
          }
          setMembershipList(memberships?.content ?? []);
        }
        groupCheck.current.schedulerId = schedulerId;
      } else {
        if (groupSelect === nameMembershipsGroup?.SILVER?.id) {
          setMembershipList(groupCheck.current.silver ?? []);
        }
        if (groupSelect === nameMembershipsGroup?.PLATINUM?.id) {
          setMembershipList(groupCheck.current.platinium ?? []);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const DetailDateSchaduler = memo(() => {
    return (
      <div className="d-flex flex-column gap-2 pb-3">
        {Object.keys(errorMembership).length > 0 && (
          <InfoErrorCode message={`No hay membresía disponible para esta programación`} />
        )}
        {schedulerListCourse?.map((scheduler) => {
          const { start_date, id, time_zone } = scheduler;
          return (
            <div key={id} className="d-flex w-auto">
              <CustomCheck
                handleCheck={(isChecked) => {
                  if (isChecked) {
                    setSelectBuyScheduler(id);
                    setSelectedSchedulerId(id);
                  }
                }}
                checked={selectedSchedulerId === id}
              />
              <div style={{ minWidth: '230px' }}>
                <EventInfo
                  className="fit-content pe-4"
                  first={'Inicio'}
                  second={getFormattedDateMultilanguage(start_date)}
                />
              </div>

              <div className={`d-flex flex-row px-3 ${'align-items-center'}`}>
                {/* <Paragraph size="16px">{parameters?.TIM_ZON_LABEL?.value}</Paragraph> */}
                <Bold size="18px">
                  {scheduler?.time_zone_id === 1
                    ? time_zone?.[scheduler?.time_zone_id - 1]
                    : time_zone?.[scheduler?.time_zone_id - 1]}
                </Bold>
              </div>
            </div>
          );
        })}
      </div>
    );
  });

  return (
    <>
      <CustomHelmet
        value={parameters?.CIS_CHMT?.value}
        description={parameters?.CIS_CHMT?.description_value}
        canonicalLink={'https://litethinking.com/course-info'}
      />

      <ModalGeneral
        isShow={showEnrrolmentForm}
        handleShow={() => {
          setShowEnrrolmentForm(false);
        }}
        onHide={() => {
          setShowEnrrolmentForm(false);
        }}
        size={'lg'}
        title={parameters?.TXT_FORM?.value}
        subtitle={nameForm}
        children={
          <UserRegisterForm
            setCloseModal={setShowEnrrolmentForm}
            onSubmit={updateData}
            setNameForm={setNameForm}
            nameForm={nameForm}
            schedulerIdCourse={parseInt(schedulerListCourse?.[0]?.id)}
            isLms
            setLoaderForm={setLoaderForm}
            loaderForm={loaderForm}
            messageError={messageError}
            setMessageError={setMessageError}
          />
        }
      />

      <ModalGeneral
        success
        isShow={modalSucces}
        handleShow={() => {
          setModalSucces(false);
          setShowEnrrolmentForm(false);
        }}
        confirm={parameters?.ACCEPT_MODAL?.value}
        onClickConfirm={() => {
          setModalSucces(false);
          setShowEnrrolmentForm(false);
        }}
        title={parameters?.SUCCESS_TRANSACTION?.value ?? 'Datos guardados con exito'}
        subtitle={parameters?.SUCCESS_TRANSACTION?.description_value ?? '21'}
      />

      <ModalGeneral
        warning
        isShow={modalError.show}
        handleShow={() => {
          setModalError({ show: false, title: null, subtitle: null });
          setShowEnrrolmentForm(false);
        }}
        confirm={parameters?.ACCEPT_MODAL?.value}
        onClickConfirm={() => {
          setModalError({ show: false, title: null, subtitle: null });
          setShow(false);
          setShowEnrrolmentForm(false);
        }}
        title={modalError.title}
        subtitle={modalError.subtitle}
      />

      <CustomLoadingOverlay loader={loader}>
        <ArrowIndicator />
        {Object.keys(membershiPriceDefault || {})?.length > 0 && (
          <FixedBar
            parameters={parametersBanner}
            membershiPriceDefault={membershiPriceDefault}
            scrollToCourseMembership={scrollToCourseMembership}
            handleClickBtn={setShowEnrrolmentForm}
            isMobile={isMobile}
            isOnline={courseItem?.mode[0].code === COURSE_MODE.ONLINE}
          />
        )}

        <ModalGeneral
          isShow={showSelectScheduler?.show}
          onHide={() => {
            setShowSelectScheduler({ show: false, membership: {} });
            setErrorMembership({});
          }}
          handleShow={setShowSelectScheduler}
          title={parametersMembership?.CONFIRM_SELECT_SCHEDULER?.value}
          subtitle={parametersMembership?.CONFIRM_SELECT_SCHEDULER?.description_value}
          size="md"
          children={<DetailDateSchaduler />}
          confirm={'Suscribirte'}
          onClickConfirm={() => handleBuy(selectBuyScheduler, true)}
        />

        <RegisterPopUp
          strategicLine={courseForBanner}
          setLoader={setLoader}
          comeFromSM={getSMSource()}
          openPopUp={showPopUp?.show}
          additionalProduct={showPopUp?.additional_product}
          afterRegistration={() => setShowPopUp({ show: false, additional_product: null })}
          showRegisterModal={showRegisterForm}
          headerPopUp={parameters?.UNIVERSITY?.value}
          parameters={parametersForm}
          language={languageKey?.id}
          colorText="white"
        />

        <BrochureBanner
          courseItem={courseItem}
          strategicLine={courseForBanner}
          setLoader={setLoader}
          parameters={parametersBanner}
          parametersBrochure={parametersForm}
          scrollToCourseMembership={scrollToCourseMembership}
        />

        <section className="bg-black text-white pt-lg-5 wrapper-portfolio pb-2">
          <div className="container">
            <Row className="">
              <Col
                md={12}
                lg={
                  schedulerListCourse?.length === 1 || schedulerListCourse?.length === 0 ? 8 : 12
                }>
                <TapsCourse
                  previewClip={courseItem?.preview_clip?.[0]?.file}
                  changeView={schedulerListCourse?.length > 1}
                  brochure={courseItem?.brochure}
                  courseItem={courseItem}
                  courseContentList={temporal}
                  parametersContentCarrousel={parametersContentCarrousel}
                  parametersCard={parameters}
                  parametersBrouchure={parametersBrouchure}
                  scrollToCourseCard={scrollToCourseCard}
                  isMobile={isMobile}
                />
              </Col>
              <Col
                className=""
                md={12}
                lg={
                  schedulerListCourse?.length === 1 || schedulerListCourse?.length === 0 ? 4 : 12
                }>
                <BuyCourseCarouselComponent
                  schedulerListCourse={schedulerListCourse}
                  changeView={schedulerListCourse?.length > 1}
                  showEnrrolmentForm={showEnrrolmentForm}
                  setShowEnrrolmentForm={setShowEnrrolmentForm}
                  handleUpdateMemberships={handleUpdateMemberships}
                  isMobile={isMobile}
                  membershipListIdScheduler={parseInt(membershipList?.[0]?.scheduler_id)}
                  language={languageKey?.id}
                  badgeImage={courseItem?.insignia_badge_scheduler}
                  {...{
                    parameters,
                    courseItem,
                    scrollToCourseMembership
                    // downloadableContent
                  }}
                />
              </Col>
            </Row>
          </div>
        </section>

        <div className="bg-black pt-1" ref={sectionMembership}>
          <MembershipSection
            modeId={courseItem?.mode?.[0]?.id}
            schedulerId={selectedSchedulerId}
            handleGroupMembership={fetchMembershipCardsLessScheduler}
            handleUpdateSelection={handleUpdateSelection}
            setCurrentSelectMembership={setCurrentSelectMembership}
            showBtnsMemberships={showBtnsMemberships}
            parameters={parametersMembership}
            nameMembershipsGroup={nameMembershipsGroup}
            membershipList={membershipList}
            scrollToCourseCard={scrollToCourseCard}
            handleBuy={handleSelectScheduler}
            schedulerNone={schedulerListCourse?.length === 0}
            scrollContainerRef={scrollContainerRef}
          />
        </div>

        <div className="bg-black text-white">
          <PaymentMethods parameters={parametersPaymentMethos} />
        </div>

        <div
          style={backgroundStyle}
          className="bg-black text-white wrapper-portfolio"
          ref={sectionReference}>
          <ConsultantsComponent
            parameters={parameters}
            consultantList={courseItem?.consultants_external}
            language={languageKey?.id}
            justConsultant
          />
        </div>
        <div className="bg-black pt-lg-0 pt-4">
          <BenefitsAndCertifications
            parameters={benefictsParams}
            language={languageKey?.id}
            landing={true}
            isOnline={courseItem?.mode[0].code === COURSE_MODE.ONLINE}
          />
        </div>

        <div className="bg-black wrapper-portfolio text-white">
          <WhyChooseUsCardGroup
            isOnline={courseItem?.mode[0].code === COURSE_MODE.ONLINE}
            parameters={parametersWhyChoise}
            pageStay={STAY_KEYS.COURSE_DETAIL}
          />
        </div>

        <div style={backgroundStyle} className="bg-black text-white">
          <ConsultantsComponent
            parameters={parameters}
            consultantList={courseItem?.consultants_internal}
            language={languageKey?.id}
            nameCourse={courseItem?.name}
            internal={true}
          />
        </div>
        <div className="bg-black">
          <WhyTakeCourse
            title={courseItem?.name}
            description={courseItem?.what_will_you_learn}
            parameters={parametersAboutDudes}
            allInfo={courseItem}
            language={languageKey.id}
          />
        </div>
      </CustomLoadingOverlay>
      {courseCampaigns.includes(courseItem?.pk) && (
        <>
          <Helmet>
            <script>
              {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-WXWZXLZ');`}
            </script>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10810669741" />
            <script>
              {`window.dataLayer = window.dataLayer || [];
              function gtag() {
                dataLayer.push(arguments);
              }
              gtag('js', new Date());
              gtag('config', 'AW-10810669741');`}
            </script>
            <script>
              {
                "gtag('event', 'conversion', { 'send_to': 'AW-10810669741/BEbVCNuP8oQDEK319qIo', 'transaction_id': '' });"
              }
            </script>
          </Helmet>
          <noscript>
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-WXWZXLZ"
              height="0"
              width="0"
              style="display:none;visibility:hidden"
            />
          </noscript>
        </>
      )}
    </>
  );
};

export default memo(CourseInfoScreen);
